import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IMainHeroProps } from '../components/main-hero/main-hero';
import { IItemsInRowComponentProps } from '../components/items-in-row/items-in-row';
import { ItemsInRowModel } from './items-in-row-model';
import { ButtonModel } from './button-model';
import { IButtonProps } from '../components/button/button';

export class MainHeroModel extends ContentItem {
  get backgroundAsset(): { url: string } {
    return get(this._config, 'elements.background_asset.value[0]', '');
  }

  get awards(): IItemsInRowComponentProps {
    const getAwards = get(this._config, 'elements.awards.value[0]', null);

    return ItemsInRowModel.create(getAwards);
  }

  get button(): IButtonProps | null {
    const getData = get(this._config, 'elements.button.value[0]', null);
    return getData ? ButtonModel.create(getData as IButton) : null;
  }

  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get description(): string {
    return get(this._config, 'elements.description_value.value', '');
  }

  get showArrowWithoutText(): boolean {
    return (
      get(
        this._config,
        'elements.show_arrow_without_text.value[0].codename'
      ) === 'true'
    );
  }

  get scrollBottomText(): string {
    return get(this._config, 'elements.scroll_to_bottom_text.value', '');
  }

  public static create(data: IMainHero): IMainHeroProps {
    const {
      backgroundAsset,
      awards,
      title,
      description,
      showArrowWithoutText,
      scrollBottomText,
      button
    } = new MainHeroModel(data);
    return {
      backgroundAsset,
      awards,
      title,
      description,
      showArrowWithoutText,
      scrollBottomText,
      button
    };
  }
}
